module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TkCaz/tc-custom/9781429975537.jpg?1737774768149",
      "alt": "This image is the cover for the book Murcheston"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murcheston\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Shrouded within the dark corners of imagination, the werewolf holds a supreme place in fable and folklore-the nightbeast, stalking its prey under the light of a full moon. Such is the popular conception. But what of the beast himself? In the novel The Wolf's Tale, a werewolf documents his own case of lycanthropy. Amid the gothic backdrop of Victorian London, the author presents three gentlemen and one woman as they share the telling of this tale-the tale of Edgar Lenoir, Duke of Darnley: aristocrat and werewolf."), _c('br'), _c('br'), _vm._v("When Lord Darnley learns that Elizabeth is pregnant with Merry's baby, he plans a hunt in the Carpathian Mountains to escape the pain of his unrequited love. Darnely goes alone and returns a changed man . . . a man who will then change Merry's and Elizabeth's lives forever."), _c('br'), _c('br'), _vm._v("The centerpiece of the novel is Lord Darnley's journal chronicling his months as a werewolf. He views his condition not with horror, but with a fascination he believes to be thoroughly modern. Unfortunately, he is also narcissistic, ruthless, and ultimately, seduced by his own misguided self-interest to justify as natural and healthy the bestial desires that eventually consume him."), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Holland\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0